<template lang="pug">
  div(v-if="show").print.map-mapping-legend
    div(
      v-if="items.length"
    ).title Легенда
    div.item
      div.legend-icon
        div(class="icon-img--active")
      div.title Действующий
    div.item
      div.legend-icon
        div(class="icon-img--planned")
      div.title Планируемый
    div(
      v-for="item of items"
    ).item
      div(
        :class="['legend-icon', `icon--${item}`, `icon--${getColor(item)}`]"
      )
        div.icon-img
      div.title {{ getTitle(item) }}
</template>

<script>
  export default {
    name: 'map-layer-legend',
    props: {
      items: {
        type: Array,
        default: () => []
      },
      layerGroups: {
        type: Object,
        default: () => {
        }
      },
      show: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      getColor(item) {
        return this.layerGroups[item] && this.layerGroups[item].color
      },
      getTitle(item) {
        return this.layerGroups[item] && this.layerGroups[item].label
      }
    }
  }
</script>
<style lang="scss">
  .legend-icon {
    width: 24px;
    height: 24px;
    border-radius: 5px;
  }
  
  .icon-img {
    &--active {
      background-size: contain;
      width: 12px;
      height: 12px;
      margin: 5px;
      border-radius: 20px;
      background: #72b429 no-repeat center center;
    }
  
    &--planned {
      background-size: contain;
      width: 12px;
      height: 12px;
      margin: 5px;
      border-radius: 20px;
      background: #ffb600 no-repeat center center;
    }
    background: center center no-repeat;
    background-size: contain;
    filter: brightness(0) invert(1);
    width: 12px;
    height: 12px;
    margin: 5px;
  }
</style>